import {
  appendContextTag,
  TRIP_PLANNER_ACTION_CONTEXT_LABEL,
} from 'tripPlanner/utils/contextTag'

export function buildConfirmStagedActionMessage(pendingActionId: string): string {
  return appendContextTag(
    'Confirm',
    `Confirm staged action pending_action_id=${pendingActionId}`,
    TRIP_PLANNER_ACTION_CONTEXT_LABEL,
  )
}

export function buildCancelStagedActionMessage(pendingActionId: string): string {
  return appendContextTag(
    'Cancel',
    `Cancel staged action pending_action_id=${pendingActionId}`,
    TRIP_PLANNER_ACTION_CONTEXT_LABEL,
  )
}
